import { useScheduleRepository } from '../repositories';

export function useScheduleWeek(weekStart: string) {
  const repo = useScheduleRepository();
  return repo.useList({ weekStart });
}

export function useCreateShift() {
  const repo = useScheduleRepository();
  const { create, loading, error } = repo.useCreate();
  return {
    mutate: (input: any) => create(input),
    mutateAsync: (input: any) => create(input),
    isPending: loading,
    loading,
    error,
  };
}
